import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './component/Auth/Login';
import Dashboard from './component/Dashboard';

import Header from './component/Header/Header';
import Footer from './component/Header/Footer';
import UserManager from './component/UserManager';
import ActiveUserManager from './component/ActiveUserManager';
import SubscriptionUserManager from './component/SubcriptionUserManager';
import ExpireUserSubcription from './component/ExpireUserSubcription';
import PendingUserSubcription from './component/PendingUserSubcription';
import SubcriptionAllUserManager from './component/SubcriptionAllUserManager';
import InActiveUserManager from './component/InActiveUserManager';
import BlockUserManager from './component/BlockUserManager';
import Vendor from './component/Vendor';
import VendorWallet from './component/VendorWallet';
import RegisterVendor from './component/RegisterVendor';
import Vendorsalary from './component/Vendorsalary';
import Vendoroderview from './component/Vendoroderview';
import BlockVendor from './component/BlockVendor';
import ActiveVendor from './component/ActiveVendor';
import InActiveVendor from './component/InActiveVendor';
import HomeSlider from './component/HomeSlider';
import WebSlider from './component/WebSlider';
import Category from './component/CategoryList';
import OrderAndDeals from './component/Order&Deals';
import AddOrderAndDeals from './component/Add Model/AddOrder&Deals';
import SubCategory from './component/SubCategoryList';
import Purchase from './component/PurchaseList';
import OtherExpenses from './component/OtherExpenses';
import Notification from './component/Notification';
import Service from './component/Service';
import Plan from './component/Plan';
import Feedback from './component/Feedback';
import VendorFeedback from './component/VendorFeedback';
import VendorWiseRating from './component/VendorWiseRating';
import Order from './component/Order';
import TodayOrder from './component/TodayOrder';
import TodayUser from './component/TodayUser';
import TodayPendingOrder from './component/TodayPendingOrder';
import TodayCompleteOrder from './component/TodayCompleteOrder';
import CompletedOrder from './component/CompletedOrder';
import PendingOrder from './component/PendingOrder';
import CancelledOrder from './component/CancelledOrder';
import OngoingOrder from './component/OngoingOrder';
import PartnerAssingOrder from './component/PartnerAssingOrder';
import StartservicesOrder from './component/StartservicesOrder';
import OutOfDeliveryOrder from './component/OutOfDeliveryOrder';
import ConfirmedOrder from './component/ConfirmedOrder';
import Addons from './component/Addons';
import Coupan from './component/Coupan';
import CoupanNew from './component/Coupannew';
import Brand from './component/Brand';
import HappyCustomer from './component/HappyCustomer';
import Vehicle from './component/Vehicle';
import Contact from './component/Contect';
import Holiday from './component/Holiday';
import Website from './component/WebsiteDescription';
import AppGSetting from './component/AppGSetting';
import District from './component/District';
import Cities from './component/Cities';
import Pincode from './component/Pincode';
import PrivacyPolicy from './component/PrivacyPolicy';
import TermCondition from './component/TermAndCondition';
import AboutUs from './component/AboutUs';
import CanclePolicy from './component/CanclePolicy';
import Location from './component/Location';
import AddHomeSlider from './component/Add Model/AddHomeSlider';
import AddWebSlider from './component/Add Model/AddWebSlider';
import AddNotification from './component/Add Model/AddNotification';
import AddPlan from './component/Add Model/AddPlan';
import AddCategory from './component/Add Model/AddCategory';
import AddSubCategory from './component/Add Model/AddSubCategory';
import AddCities from './component/Add Model/AddCities';
import AddPincode from './component/Add Model/AddPincode';
import AddPurchase from './component/Add Model/AddPurchase';
import AddOtherExpenses from './component/Add Model/AddOtherExpenses';
import AddService from './component/Add Model/AddService';
import AddBrand from './component/Add Model/AddBrand';
import AddVehicle from './component/Add Model/AddVehicle';
import AddAddons from './component/Add Model/AddAddons';
import AddCoupan from './component/Add Model/AddCoupan';
import AddCoupanNew from './component/Add Model/AddCoupanNew';
import AddLocation from './component/Add Model/AddLocation';
import AddTimeSlot from './component/Add Model/AddTimeSlot';
import AddHappyCustomer from './component/Add Model/AddHappyCustomer';
import Settings from './component/Settings';
import Profile from './component/Profile';
import AddAdmin from './component/Add Model/AddAdmin';
import AdminUser from './component/AdminUser';
import Refer from './component/Refer';
import TimeSlot from './component/Timeslot';
import PushMessage from './component/PushNotificationList';
import NumberBooking from './component/NumberBooking';
import UserPermission from './component/UserPermission';
import VendorAttendance from './component/VendorAttendance';
import EnquiryList from './component/EnquiryList';
import BalanceSheet from './component/BalanceSheet';

const PrivateRoute = ({ children, isAuthenticated, requiredPermission, isAdmin }) => {
  const permissions = JSON.parse(localStorage.getItem('userPermissions')) || {};

  if (isAuthenticated === null) {
    return <div className="loader design_loading">Loading...</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }
  if (!isAdmin && !permissions[requiredPermission]) {
    return <Navigate to="/dashboard" />;
  }
  return children;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [role, setRole] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {

    const token = localStorage.getItem('authToken');
    const userRole = localStorage.getItem('userRole');
    if (token && userRole) {
      setIsAuthenticated(true);
      setRole(userRole);
      setIsAdmin(userRole === 'Admin');
    } else {
      setIsAuthenticated(false);
    }
  }, [role]);

  return (
    <Router>
      {isAuthenticated && <Header />}
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? <Navigate to="/dashboard" /> : <Login setIsAuthenticated={setIsAuthenticated} setRole={setRole} />
          }
        />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="dashboard" isAdmin={isAdmin}>
              <Dashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/user-permission"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="user-permission" isAdmin={isAdmin}>
              <UserPermission />
            </PrivateRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="users" isAdmin={isAdmin}>
              <UserManager />
            </PrivateRoute>
          }
        />

        <Route
          path="/active-users"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="users" isAdmin={isAdmin}>
              <ActiveUserManager />
            </PrivateRoute>
          }
        />

        <Route
          path="/subcription-active-users"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="users" isAdmin={isAdmin}>
              <SubscriptionUserManager />
            </PrivateRoute>
          }
        />

        <Route
          path="/subcription-expire-users"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="users" isAdmin={isAdmin}>
              <ExpireUserSubcription />
            </PrivateRoute>
          }
        />

        <Route
          path="/subcription-panding-users"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="users" isAdmin={isAdmin}>
              <PendingUserSubcription />
            </PrivateRoute>
          }
        />





        <Route
          path="/subcription-all-users"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="users" isAdmin={isAdmin}>
              <SubcriptionAllUserManager />
            </PrivateRoute>
          }
        />


        SubcriptionAllUserManager

        <Route
          path="/inactive-users"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="users" isAdmin={isAdmin}>
              <InActiveUserManager />
            </PrivateRoute>
          }
        />

        <Route
          path="/block-users"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="users" isAdmin={isAdmin}>
              <BlockUserManager />
            </PrivateRoute>
          }
        />

        <Route
          path="/register-vendor"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="registervendor" isAdmin={isAdmin}>
              <RegisterVendor />
            </PrivateRoute>
          }
        />

        <Route
          path="/vendor"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="vendor" isAdmin={isAdmin}>
              <Vendor />
            </PrivateRoute>
          }
        />
        <Route
          path="/Vendoroderview"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="Vendoroderview" isAdmin={isAdmin}>
              <Vendoroderview />
            </PrivateRoute>
          }
        />

        <Route
          path="/active-vendor"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="vendor" isAdmin={isAdmin}>
              <ActiveVendor />
            </PrivateRoute>
          }
        />

        <Route
          path="/inactive-vendor"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="vendor" isAdmin={isAdmin}>
              <InActiveVendor />
            </PrivateRoute>
          }
        />

        <Route
          path="/block-vendor"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="vendor" isAdmin={isAdmin}>
              <BlockVendor />
            </PrivateRoute>
          }
        />


        <Route
          path="/vendor-wallet"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="vendor" isAdmin={isAdmin}>
              <VendorWallet />
            </PrivateRoute>
          }
        />

        <Route
          path="/salary-managment"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="vendorsalary" isAdmin={isAdmin}>
              <Vendorsalary />
            </PrivateRoute>
          }
        />





        <Route
          path="/home-slider"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="home-slider" isAdmin={isAdmin}>
              <HomeSlider />
            </PrivateRoute>
          }
        />
        <Route
          path="/web-slider"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="web-slider" isAdmin={isAdmin}>
              <WebSlider />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-home-slider"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="home-slider" isAdmin={isAdmin}>
              <AddHomeSlider />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-web-slider"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="web-slider" isAdmin={isAdmin}>
              <AddWebSlider />
            </PrivateRoute>
          }
        />
        <Route
          path="/feedback"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="feedback" isAdmin={isAdmin}>
              <Feedback />
            </PrivateRoute>
          }
        />

        <Route
          path="/vendor-review"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="VendorFeedback" isAdmin={isAdmin}>
              <VendorFeedback />
            </PrivateRoute>
          }
        />

        <Route
          path="/vendor-wise-review"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="VendorFeedback" isAdmin={isAdmin}>
              <VendorWiseRating />
            </PrivateRoute>
          }
        />

        <Route
          path="/category"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="category" isAdmin={isAdmin}>
              <Category />
            </PrivateRoute>
          }
        />
        <Route
          path="/order-and-deals"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="order" isAdmin={isAdmin}>
              <OrderAndDeals />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-order-and-deals"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="order" isAdmin={isAdmin}>
              <AddOrderAndDeals />
            </PrivateRoute>
          }
        />

        <Route
          path="/add-category"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="category" isAdmin={isAdmin}>
              <AddCategory />
            </PrivateRoute>
          }
        />

        <Route
          path="/subcategory"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="subcategory" isAdmin={isAdmin}>
              <SubCategory />
            </PrivateRoute>
          }
        />

        <Route
          path="/add-subcategory"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="category" isAdmin={isAdmin}>
              <AddSubCategory />
            </PrivateRoute>
          }
        />

        <Route
          path="/add-city"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="city" isAdmin={isAdmin}>
              <AddCities />
            </PrivateRoute>
          }
        />

        <Route
          path="/add-pincode"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="pincode" isAdmin={isAdmin}>
              <AddPincode />
            </PrivateRoute>
          }
        />



        <Route
          path="/service"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="service" isAdmin={isAdmin}>
              <Service />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-service"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="service" isAdmin={isAdmin}>
              <AddService />
            </PrivateRoute>
          }
        />
        <Route
          path="/brand"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="brand" isAdmin={isAdmin}>
              <Brand />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-brand"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="brand" isAdmin={isAdmin}>
              <AddBrand />
            </PrivateRoute>
          }
        />
        <Route
          path="/vehicle"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="vehicle" isAdmin={isAdmin}>
              <Vehicle />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-vehicle"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="vehicle" isAdmin={isAdmin}>
              <AddVehicle />
            </PrivateRoute>
          }
        />
        <Route
          path="/contact-us"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="contact-us" isAdmin={isAdmin}>
              <Contact />
            </PrivateRoute>
          }
        />

        <Route
          path="/holiday"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="contact-us" isAdmin={isAdmin}>
              <Holiday />
            </PrivateRoute>
          }
        />


        <Route
          path="/website"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="website" isAdmin={isAdmin}>
              <Website />
            </PrivateRoute>
          }
        />

        <Route
          path="/app-setting"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="appwebsite" isAdmin={isAdmin}>
              <AppGSetting />
            </PrivateRoute>
          }
        />


        <Route
          path="/district"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="district" isAdmin={isAdmin}>
              <District />
            </PrivateRoute>
          }
        />

        <Route
          path="/Cities"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="cities" isAdmin={isAdmin}>
              <Cities />
            </PrivateRoute>
          }
        />


        <Route
          path="/Pincode"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="pincode" isAdmin={isAdmin}>
              <Pincode />
            </PrivateRoute>
          }
        />


        <Route
          path="/notification"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="notification" isAdmin={isAdmin}>
              <Notification />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-notification"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="notification" isAdmin={isAdmin}>
              <AddNotification />
            </PrivateRoute>
          }
        />
        <Route
          path="/plan"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="plan" isAdmin={isAdmin}>
              <Plan />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-plan"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="plan" isAdmin={isAdmin}>
              <AddPlan />
            </PrivateRoute>
          }
        />
        <Route
          path="/order"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="order" isAdmin={isAdmin}>
              <Order />
            </PrivateRoute>
          }
        />

        <Route
          path="/today-order"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="TodayOrder" isAdmin={isAdmin}>
              <TodayOrder />
            </PrivateRoute>
          }
        />


        <Route
          path="/today-user"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="TodayUser" isAdmin={isAdmin}>
              <TodayUser />
            </PrivateRoute>
          }
        />



        <Route
          path="/today-pending-order"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="TodaypendingOrder" isAdmin={isAdmin}>
              <TodayPendingOrder />
            </PrivateRoute>
          }
        />

        <Route
          path="/today-complete-order"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="TodayCompleteOrder" isAdmin={isAdmin}>
              <TodayCompleteOrder />
            </PrivateRoute>
          }
        />



        <Route
          path="/pending-order"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="order" isAdmin={isAdmin}>
              <PendingOrder />
            </PrivateRoute>
          }
        />

        <Route
          path="/cancelled-order"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="order" isAdmin={isAdmin}>
              <CancelledOrder />
            </PrivateRoute>
          }
        />

        <Route
          path="/ongoing-order"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="order" isAdmin={isAdmin}>
              <OngoingOrder />
            </PrivateRoute>
          }
        />

        <Route
          path="/pending-orders"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="order" isAdmin={isAdmin}>
              <PartnerAssingOrder />
            </PrivateRoute>
          }
        />

        <Route
          path="/service-start"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="order" isAdmin={isAdmin}>
              <StartservicesOrder />
            </PrivateRoute>
          }
        />

        <Route
          path="/confirmed-order"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="order" isAdmin={isAdmin}>
              <ConfirmedOrder />
            </PrivateRoute>
          }
        />

        <Route
          path="/ongoing-orders"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="order" isAdmin={isAdmin}>
              <OutOfDeliveryOrder />
            </PrivateRoute>
          }
        />


        <Route
          path="/completed-order"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="order" isAdmin={isAdmin}>
              <CompletedOrder />
            </PrivateRoute>
          }
        />


        <Route
          path="/addons"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="addons" isAdmin={isAdmin}>
              <Addons />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-addons"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="addons" isAdmin={isAdmin}>
              <AddAddons />
            </PrivateRoute>
          }
        />
        <Route
          path="/coupon"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="coupon" isAdmin={isAdmin}>
              <Coupan />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-coupon"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="coupon" isAdmin={isAdmin}>
              <AddCoupan />
            </PrivateRoute>
          }
        />

        <Route
          path="/add-couponNew"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="couponnew" isAdmin={isAdmin}>
              <AddCoupanNew />
            </PrivateRoute>
          }
        />


        <Route
          path="/couponnew"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="couponNew" isAdmin={isAdmin}>
              <CoupanNew />
            </PrivateRoute>
          }
        />

        <Route
          path="/about-us"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="pages" isAdmin={isAdmin}>
              <AboutUs />
            </PrivateRoute>
          }
        />
        <Route
          path="/happy-customer"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="coupon" isAdmin={isAdmin}>
              <HappyCustomer />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-happy-customer"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="coupon" isAdmin={isAdmin}>
              <AddHappyCustomer />
            </PrivateRoute>
          }
        />
        <Route
          path="/terms-and-condition"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="pages" isAdmin={isAdmin}>
              <TermCondition />
            </PrivateRoute>
          }
        />
        <Route
          path="/cancellation-policy"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="pages" isAdmin={isAdmin}>
              <CanclePolicy />
            </PrivateRoute>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="pages" isAdmin={isAdmin}>
              <PrivacyPolicy />
            </PrivateRoute>
          }
        />
        <Route
          path="/terms-condition"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="pages" isAdmin={isAdmin}>
              <TermCondition />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-admin"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <AddAdmin />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <AdminUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-location"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <AddLocation />
            </PrivateRoute>
          }
        />
        <Route
          path="/location"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <Location />
            </PrivateRoute>
          }
        />
        <Route
          path="/refer"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <Refer />
            </PrivateRoute>
          }
        />
        <Route
          path="/time-slot"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <TimeSlot />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-time-slot"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <AddTimeSlot />
            </PrivateRoute>
          }
        />
        <Route
          path="/numberofbooking"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <NumberBooking />
            </PrivateRoute>
          }
        />
        <Route
          path="/push-notification"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <PushMessage />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <Settings />
            </PrivateRoute>
          }
        />

        <Route
          path="/purchase"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="purchase" isAdmin={isAdmin}>
              <Purchase />
            </PrivateRoute>
          }
        />


        <Route
          path="/add-purchase"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="addpurchase" isAdmin={isAdmin}>
              <AddPurchase />
            </PrivateRoute>
          }
        />


        <Route
          path="/other-expenses"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="OtherExpenses" isAdmin={isAdmin}>
              <OtherExpenses />
            </PrivateRoute>
          }
        />


        <Route
          path="/add-other-expenses"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="addOtherExpenses" isAdmin={isAdmin}>
              <AddOtherExpenses />
            </PrivateRoute>
          }
        />




        <Route
          path="/vendor-attendance"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="vendorsalary" isAdmin={isAdmin}>
              <VendorAttendance />
            </PrivateRoute>
          }
        />

        <Route
          path="/enquiry-list"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="EnquiryList" isAdmin={isAdmin}>
              <EnquiryList />
            </PrivateRoute>
          }
        />

        <Route
          path="/balance-sheet"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="BalanceSheet" isAdmin={isAdmin}>
              <BalanceSheet />
            </PrivateRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <Profile />
            </PrivateRoute>
          }
        />

      </Routes>
      {isAuthenticated && <Footer />}
    </Router>
  );
}

export default App;